<!-- 海报 -->
<template>
  <van-popup
    v-model="visible"
    get-container="body"
    style="background-color: transparent; overflow-y: visible"
    @opened="handleShareOpened"
    @closed="$emit('closed')"
  >
    <div :class="$style.poster">
      <btn-close
        style="z-index: 1; position: absolute; top: -.5rem; right: 0;"
        @click="visible = false"
      />
      <div id="j-canvas-wish" :class="$style.canvas">
        <img
          :src="posterUrl"
          style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"
        />
        <img
          :src="
            require(isChannel
              ? './images/poster-qrc-channel.jpg'
              : './images/poster-qrc.jpg')
          "
          style="position: absolute; bottom: 1.1rem; right: .64rem; width: 1.5rem; height: 1.5rem;"
        />
      </div>
      <div :class="$style.screenshot" :style="{ opacity: isDebug ? 1 : 0 }">
        <img :src="screenUrl" />
      </div>
    </div>
  </van-popup>
</template>

<script>
import { mapGetters } from "vuex";
import html2canvas from "html2canvas";
import { imageToBase64, getQueryString } from "@/utils";
import BtnClose from "../BtnClose";

export default {
  name: "PopupPoster",
  components: {
    BtnClose
  },
  props: {
    /** 海报图 */
    poster: String
  },
  data() {
    return {
      visible: false,
      isDebug: getQueryString("debug") === "985",
      // 分享图地址
      screenUrl: "",
      // 海报图地址
      posterUrl: "",
      posterWatcher: null
    };
  },
  computed: {
    ...mapGetters(["isChannel"])
  },
  mounted() {
    // 将海报图转为 base64
    if (this.poster) {
      imageToBase64(this.poster, base64 => {
        this.posterUrl = base64;
      });
    } else {
      this.posterWatcher = this.$watch("poster", val => {
        if (val) {
          imageToBase64(val, base64 => {
            this.posterUrl = base64;
          });
          this.posterWatcher();
        }
      });
    }
  },
  methods: {
    show() {
      this.visible = true;
    },
    handleShareOpened() {
      // 图片生成
      html2canvas(document.querySelector("#j-canvas-wish"), {
        backgroundColor: "#000"
      }).then(canvas => {
        this.screenUrl = canvas.toDataURL();
      });
    }
  }
};
</script>

<style lang="less" module>
.poster {
  .size(6.82rem, 10.9rem);

  &::after {
    .size(5.73rem, 0.28rem);
    .background-fill("./images/poster-tip.png");

    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -0.5rem;
    margin: 0 auto;
    pointer-events: none;
  }

  .canvas {
    .size(100%);

    position: relative;
  }

  .screenshot {
    .size(100%);

    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
    opacity: 0;

    img {
      .size(100%);
    }
  }
}
</style>
